import styles from '../Modal/ConfirmationModal.module.css'
import success from '../..//assets/icons/success-icon.svg'

const SuccessCard = ({confirm, logout, successMessage, customMessage, type = "card"}) => {
  return (
    <div>
          <div className='d-flex flex-column justify-content-center align-items-center'>
              <img src={success} alt="modal icon" className='my-4'/>
            <h6 className='fw-medium fs-3'>Successful</h6>
            <p>{successMessage}</p>
            <button 
              onClick={() => {
                confirm();
                type=== "login" && logout();
              }} 
              className={`${styles.modalButton} ${styles.modal_confirm} mb-2 text-white`}>
              {customMessage ? customMessage : "Done"}
            </button>
        </div>
      </div>
  )
}

export default SuccessCard